import { createFileRoute } from '@tanstack/react-router';

import { ApiSettingsPage } from '@/features/settings';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/api')({
  component: ApiSettingsPage,
});
